// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"434":"38ce66099a500357","452":"3b1c594f3b51502e","497":"307c543d7f4997ad","531":"4a879910d138fc4b","861":"18f15588fefb80dd","988":"51e180d7933e2915"}[chunkId] + ".js";
};